import { httpClient } from "@coworker/http-client";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Image } from "../types/imageUpload";

async function addImageToTask(taskId: string, images: Image[]) {
  return await httpClient.tasks.post(`/v1/task/${taskId}/images/create`, {
    body: { list: images },
  });
}

export function useAttachImageToTask(taskId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (data: { images: Image[] }) => {
      return await addImageToTask(taskId, data.images);
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ["task", "images", taskId],
      });
    },
    onError: (error) => {
      console.log("Error while updating task", error);
    },
  });
}
